import React from 'react';

/**
 * Highlights matched text in a string by wrapping it in mark elements
 * This function works with plain text (no HTML tags expected)
 *
 * @param text The text to search within (plain text)
 * @param searchTerm The search term to highlight
 * @returns React elements with matched text wrapped in mark tags
 */
export function highlightText(text: string, searchTerm: string): string | React.ReactNode[] {
  if (!searchTerm || !text) return text;

  const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part, index) => {
    if (part && regex.test(part)) {
      // Reset regex lastIndex to avoid issues with global flag
      regex.lastIndex = 0;
      return (
        <mark key={index} className="bg-yellow-400/50">
          {part}
        </mark>
      );
    }
    // Reset regex lastIndex for next iteration
    regex.lastIndex = 0;
    return part;
  });
}

